import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PasskeyController::update
 * @see app/Http/Controllers/PasskeyController.php:53
 * @route '/account/2fa/passkeys/{credentialId}'
 */
export const update = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/account/2fa/passkeys/{credentialId}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\PasskeyController::update
 * @see app/Http/Controllers/PasskeyController.php:53
 * @route '/account/2fa/passkeys/{credentialId}'
 */
update.url = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { credentialId: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    credentialId: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        credentialId: args.credentialId,
                }

    return update.definition.url
            .replace('{credentialId}', parsedArgs.credentialId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasskeyController::update
 * @see app/Http/Controllers/PasskeyController.php:53
 * @route '/account/2fa/passkeys/{credentialId}'
 */
update.patch = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

    /**
* @see \App\Http\Controllers\PasskeyController::update
 * @see app/Http/Controllers/PasskeyController.php:53
 * @route '/account/2fa/passkeys/{credentialId}'
 */
    const updateForm = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: update.url(args, {
                    [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                        _method: 'PATCH',
                        ...(options?.query ?? options?.mergeQuery ?? {}),
                    }
                }),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasskeyController::update
 * @see app/Http/Controllers/PasskeyController.php:53
 * @route '/account/2fa/passkeys/{credentialId}'
 */
        updateForm.patch = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: update.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'PATCH',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'post',
        })
    
    update.form = updateForm
/**
* @see \App\Http\Controllers\PasskeyController::destroy
 * @see app/Http/Controllers/PasskeyController.php:76
 * @route '/account/2fa/passkeys/{credentialId}'
 */
export const destroy = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/account/2fa/passkeys/{credentialId}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\PasskeyController::destroy
 * @see app/Http/Controllers/PasskeyController.php:76
 * @route '/account/2fa/passkeys/{credentialId}'
 */
destroy.url = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { credentialId: args }
    }

    
    if (Array.isArray(args)) {
        args = {
                    credentialId: args[0],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        credentialId: args.credentialId,
                }

    return destroy.definition.url
            .replace('{credentialId}', parsedArgs.credentialId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasskeyController::destroy
 * @see app/Http/Controllers/PasskeyController.php:76
 * @route '/account/2fa/passkeys/{credentialId}'
 */
destroy.delete = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

    /**
* @see \App\Http\Controllers\PasskeyController::destroy
 * @see app/Http/Controllers/PasskeyController.php:76
 * @route '/account/2fa/passkeys/{credentialId}'
 */
    const destroyForm = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: destroy.url(args, {
                    [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                        _method: 'DELETE',
                        ...(options?.query ?? options?.mergeQuery ?? {}),
                    }
                }),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\PasskeyController::destroy
 * @see app/Http/Controllers/PasskeyController.php:76
 * @route '/account/2fa/passkeys/{credentialId}'
 */
        destroyForm.delete = (args: { credentialId: string | number } | [credentialId: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: destroy.url(args, {
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'DELETE',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'post',
        })
    
    destroy.form = destroyForm
/**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/account/2fa/passkeys',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

    /**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
    const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
        action: index.url(options),
        method: 'get',
    })

            /**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
        indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: index.url(options),
            method: 'get',
        })
            /**
* @see \App\Http\Controllers\PasskeyController::index
 * @see app/Http/Controllers/PasskeyController.php:41
 * @route '/account/2fa/passkeys'
 */
        indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
            action: index.url({
                        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
                            _method: 'HEAD',
                            ...(options?.query ?? options?.mergeQuery ?? {}),
                        }
                    }),
            method: 'get',
        })
    
    index.form = indexForm
const passkeys = {
    update: Object.assign(update, update),
destroy: Object.assign(destroy, destroy),
index: Object.assign(index, index),
}

export default passkeys